import { createTheme } from "@mui/material/styles";

const getTheme = (darkMode) =>
  createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      ...(darkMode
        ? {
            // 🌙 Dark mode
            primary: { main: "#2f81f7" }, // modern blue
            secondary: { main: "#a371f7" }, // soft violet
            background: {
              default: "#0d1117", // deep background
              paper: "#161b22", // cards/panels
            },
            text: {
              primary: "#e6edf3",
              secondary: "#8b949e",
            },
          }
        : {
            // ☀️ Light mode
            primary: { main: "#0052cc" }, // modern blue
            secondary: { main: "#7a4ff6" }, // accent purple
            background: {
              default: "#f5f7fa", // subtle gray
              paper: "#ffffff", // cards/panels
            },
            text: {
              primary: "#1a1a1a",
              secondary: "#555e6b",
            },
          }),
    },
    typography: {
      fontFamily: `"Inter", "Roboto", "Helvetica", "Arial", sans-serif`,
      h6: { fontWeight: 600 },
      body1: { fontSize: "0.95rem" },
      body2: { fontSize: "0.85rem", color: "text.secondary" },
    },
    shape: {
      borderRadius: 8, // smoother UI
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 10,
            boxShadow: darkMode
              ? "0px 0px 12px rgba(0,0,0,0.5)"
              : "0px 2px 8px rgba(0,0,0,0.08)",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none", // no ALL CAPS
            borderRadius: 6,
            fontWeight: 500,
          },
        },
      },
    },
  });

export default getTheme;
